export default __webpack_public_path__ + "fonts/504156c32de97d730492dd752b42b6aa.ttf";